import MenuSeeAll from './MenuSeeAll';

export default MenuSeeAll;
